import { createFileRoute } from '@tanstack/react-router'

import SignUpForm from '@/screens/auth/SignUpForm'

export const Route = createFileRoute('/_auth/signup')({ component: SignUpForm })
